import * as type from '../actions/types';

const initialState = {
  profile: [],
  loading: false,
  error: null,
}

export default function getProfileData(state = initialState, action) {
  switch (action.type) {
    case type.GET_PROFILE_DATA_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case type.GET_PROFILE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        profile: action.data,
        // error:action.errors
      }
    case type.GET_PROFILE_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state
  }
}